import { createReducer, on } from '@ngrx/store';
import * as NotificationActions from './notification.actions';
import { Notification } from '../../models/Notification';

export interface NotificationState {
  notifications: Notification[];
  loading: boolean;
  error: any;
}

export const initialState: NotificationState = {
  notifications: [],
  loading: false,
  error: null,
};

export const notificationReducer = createReducer(
  initialState,
  on(NotificationActions.loadNotifications, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(NotificationActions.loadNotificationsSuccess, (state, { notifications }) => ({
    ...state,
    notifications,
    loading: false,
  })),
  on(NotificationActions.loadNotificationsFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(NotificationActions.notify, (state) => ({
    ...state,
    loading: true,
    error: null,
  })),
  on(NotificationActions.notifySuccess, (state) => ({
    ...state,
    loading: false,
  })),
  on(NotificationActions.notifyFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(NotificationActions.loadNotificationsForCustomer, (state) => ({
    ...state,
    loading: true,
  })),
  on(NotificationActions.loadNotificationsForCustomerSuccess, (state, { notifications }) => ({
    ...state,
    loading: false,
    notifications,
  })),
  on(NotificationActions.loadNotificationsForCustomerFailure, (state, { error }) => ({
    ...state,
    loading: false,
    error,
  })),
  on(NotificationActions.markAsReadSuccess, (state, { id }) => ({
  ...state,
  notifications: state.notifications.map(n => n.id === id ? { ...n, isRead: true } : n),
  })),
  on(NotificationActions.createNotificationSuccess, (state, { notification }) => ({
    ...state,
    notifications: [notification, ...state.notifications],
  })),
  on(NotificationActions.markAllAsReadSuccess, (state) => ({
    ...state,
    notifications: state.notifications.map(n => ({ ...n, isRead: true })),
  })),
);
